export const DATE_FORMATS = [
  'DD MMMM YYYY',
  'DD MMM YYYY',
  'DD-MM-YYYY',
  'MM-DD-YYYY',
  'YYYY-MM-DD',
];
